var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.502,
    height: 17.716,
    viewBox: "0 0 15.502 17.716",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1d0e3d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.5,7.586,13.377,6.463l-5.62,5.618a2.384,2.384,0,0,0,3.372,3.371L17.872,8.71a3.973,3.973,0,0,0-5.619-5.618l-7.08,7.079-.015.015A5.541,5.541,0,1,0,13,18.022l.014-.015h0l4.833-4.832-1.124-1.123-4.833,4.832-.015.015a3.952,3.952,0,0,1-5.59-5.588L6.3,11.3h0l7.081-7.079a2.384,2.384,0,1,1,3.372,3.371l-6.743,6.742a.795.795,0,0,1-1.124-1.123L14.5,7.586Z",
    transform: "translate(-3.535 -1.928)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.4c5c0e7135e6681836ea0d864d48fc6c.svg";
export { ForwardRef as ReactComponent };